<app-public-navigation/>

<section class="pricing-section">
  <div class="container">
    <h1 class="display-5 text-center my-4">Preis</h1>

    <div class="pricing-card shadow-sm">
      <div class="pricing-header">
        <h2 class="plan-name">TaskRadar</h2>
        <div class="price">
          <span class="amount">€ 49</span>
          <span class="per">/ Monat</span>
        </div>
      </div>
      <ul class="features list-unstyled mt-3 mb-4">
        <li><i class="fas fa-check text-success me-2"></i> Einmalige Einrichtung innerhalb von 24h</li>
        <li><i class="fas fa-check text-success me-2"></i> Alle Kernfunktionen inklusive</li>
        <li><i class="fas fa-check text-success me-2"></i> DSGVO-konforme Datenhaltung in der EU</li>
        <li><i class="fas fa-check text-success me-2"></i> Support per E‑Mail</li>
      </ul>
      <div class="text-center">
        <a class="btn btn-danger btn-lg" href="mailto:kontakt@noteradar.at">Jetzt Zugang anfordern</a>
      </div>
    </div>

    <p class="text-muted text-center mt-3 small">Alle Preise verstehen sich exkl. USt.</p>
  </div>
</section>

<app-public-footer></app-public-footer>
